import { createError } from '@adv-frontend/error';

import { getFormStoreSingleton } from '../../store/store';

/** Ошибка, которая происходит если попытаться обратиться к данным формы, которая не проинициализирована */
export const FormNotInitializedError = createError<{ name: string; id: string }>('FormNotInitializedError');

/** Выбрасывает исключение, если форма не проинициализирована */
export function assertFormInitialized(params: { formName: string; formId: string; formInitializationId: string }) {
    const { isFormInitialized } = getFormStoreSingleton(params.formName);

    if (!isFormInitialized({ formInitializationId: params.formInitializationId })) {
        throw new FormNotInitializedError('Form not initialized', {
            cause: null,
            additional: {
                name: params.formName,
                id: params.formId,
            },
            groupBy: {
                name: params.formName,
            },
        });
    }
}
